import React from 'react';
import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import commentIcon from '../../../assets/icons/commentIcon.svg';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';
import Annotations from '../Annotations';

class ToolShowComments extends Tool {
  static toolName = 'Show comments';
  static iconClass = 'far fa-comment';

  static action({ controller }: ToolArgsWithController): void {
    const provider = controller.ahaEditor.getProvider('annotations');
    if (!provider) return;

    provider.onShowAnnotations();
  }

  static isEnabled(): boolean {
    return true;
  }

  static renderToolbarButtonIcon(
    toolArgs: ToolArgsWithController
  ): JSX.Element {
    const { editor } = toolArgs;

    const commentCount = Annotations.getFilteredAnnotations(editor, {
      kind: 'comment',
      resolved: false,
      hidden: false,
      excludeLocalOnly: true,
    }).length;

    return (
      <>
        {svgToIcon(commentIcon)}
        {commentCount > 0 && <span className="tw-ml-1">{commentCount}</span>}
      </>
    );
  }

  static available({ controller }: ToolArgsWithController): boolean {
    const fullScreenProvider = controller.ahaEditor?.getProvider('fullScreen');
    if (fullScreenProvider?.isFullScreen) {
      return false;
    }

    return controller.ahaEditor.hasProvider('annotations');
  }
}

export default ToolShowComments;
